import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getTranslations } from '../utils/translations';
import './About.css';

export default function About() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Activity images for the carousel
  const activityImages = [
    {
      src: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=1200&q=80',
      alt: 'Person on parachute skydiving'
    },
    {
      src: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=1200&q=80',
      alt: 'Cozy jacuzzi in nature'
    },
    {
      src: '/images/krakow.jpg',
      alt: 'Krakow, Poland'
    },
    {
      src: '/images/warsaw.jpg',
      alt: 'Warsaw, Poland'
    }
  ];
  
  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % activityImages.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [activityImages.length]);
  
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  
  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + activityImages.length) % activityImages.length);
  };
  
  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % activityImages.length);
  };
  
  // Split description into paragraphs
  const paragraphs = t.about.description.split('\n\n').filter(p => p.trim());
  
  return (
    <section id="about" className="about">
      <div className="about-container">
        <h2>{t.about.title}</h2>
        <div className="about-content">
          <div className="about-text">
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div className="about-gallery">
            <div className="gallery-carousel">
              <div className="carousel-container">
                {activityImages.map((image, index) => (
                  <div
                    key={index}
                    className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                  >
                    <img src={image.src} alt={image.alt} />
                  </div>
                ))}
              </div>
              <button className="carousel-button carousel-prev" onClick={goToPrevious} aria-label="Previous">
                &#8249;
              </button>
              <button className="carousel-button carousel-next" onClick={goToNext} aria-label="Next">
                &#8250;
              </button>
              <div className="carousel-indicators">
                {activityImages.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
